module.exports = __webpack_public_path__ + "static/images/fe679abe.png";